import { Form, Formik } from "formik";
import React, { FC, ReactElement, useEffect, useState } from "react";
import Modal from "react-modal";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Lookup } from "../../models/Lookup";
import { SearchTerm } from "../../models/search/SearchTerm";
import { TableColumn } from "../../models/table/TableColumn";
import WizardSideBarStep from "../../models/WizardSideBarStep";
import WizardTwo from "../wizard/wizardTwo";
import AssignStep from "./AssignStep";
import SummaryStep from "./SummaryStep";

interface AssignModalProps {
    /**
     * This should be the name of what is being assigned and it should be passed translated
     */
    assigningTitle: string;
    modalTitle: string;
    tableColumns: TableColumn[];
    searchColumns: SearchTerm[];
    dataMethod: (listParameter?: any) => Promise<any>;
    isOpen: boolean;
    onClose: () => void;
    getAssignedItems: (setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>, setSelectedRows: React.Dispatch<React.SetStateAction<any[]>>, setOriginalSelectedIds: React.Dispatch<React.SetStateAction<string[]>>, setOriginalSelectedRows: React.Dispatch<React.SetStateAction<any[]>>, setAlwaysSelectedAndDisabled?: React.Dispatch<React.SetStateAction<string[]>>) => void;
    handleSubmit: (toBeAssigned: string[], toBeUnassigned: string[]) => void;
    lookup?: Lookup[];
    idPath?: string;
}

const AssignModalTwo: FC<AssignModalProps> = ({ assigningTitle, dataMethod, searchColumns, tableColumns, onClose, isOpen, getAssignedItems, handleSubmit, lookup = [], modalTitle, idPath = "id" }) => {
    const { translate } = useLocale();
    const [totalSelected, setTotalSelected] = useState<number>(0);
    const [step, setStep] = useState<number>(0);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const [originalSelectedIds, setOriginalSelectedIds] = useState<string[]>([]);
    const [originalSelectedRows, setOriginalSelectedRows] = useState<any[]>([]);
    const [alwaysSelectedAndDisabled, setAlwaysSelectedAndDisabled] = useState<string[]>([]);
    const initialValues = {
        selectedIds: [],
        selectedRows: [],
    }

    useEffect(() => {
        if (isOpen) {
            getAssignedItems(setSelectedIds, setSelectedRows, setOriginalSelectedIds, setOriginalSelectedRows, setAlwaysSelectedAndDisabled);
        }
    }, [isOpen]);

    const steps: WizardSideBarStep[] = [
        {
            title: assigningTitle,
            description: totalSelected !== 0 ? translate.byKeyFormatted(TranslationKeys.selectedWithCount, [totalSelected]) : translate.byKey(TranslationKeys.pending),
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: translate.byKey(TranslationKeys.pending),
            substeps: []
        },
    ];

    const onNext = (e: any) => {
        setStep(step + 1);
    }

    const onBack = (e: any) => {
        setStep(step - 1);
    }

    const content: ReactElement[] = [
        <AssignStep
            dataMethod={dataMethod}
            onNext={onNext}
            searchColumns={searchColumns}
            tableColumns={tableColumns}
            setTotalSelected={setTotalSelected}
            title={assigningTitle}
            lookup={lookup}
            selectedIds={selectedIds}
            selectedRows={selectedRows}
            setSelectedIds={setSelectedIds}
            setSelectedRows={setSelectedRows}
            alwaysSelectedAndDisabled={alwaysSelectedAndDisabled}
            originalSelectedIds={originalSelectedIds} />,
        <SummaryStep
            originalSelectedRows={originalSelectedRows}
            onBack={onBack}
            idPath={idPath} />
    ]

    const onSubmit = (values: any) => {
        const toBeUnassigned = originalSelectedIds.filter((id: string) => !values.selectedIds.includes(id));
        const toBeAssigned = values.selectedIds.filter((id: string) => !originalSelectedIds.includes(id));
        handleSubmit(toBeAssigned, toBeUnassigned);
        onLocalClose();
    }

    const onLocalClose = () => {
        setStep(0);
        setTotalSelected(0);
        onClose();
    }

    return <Modal
        isOpen={isOpen}
        onRequestClose={onLocalClose}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            onSubmit={onSubmit}>
            <Form>
                <WizardTwo
                    name={modalTitle}
                    step={step}
                    onClose={onLocalClose}
                    sidebarSteps={steps}
                    stepContent={content} />
            </Form>
        </Formik>
    </Modal>
}

export default AssignModalTwo;